let pixels = {};

const state = {
  insertion: "fm",
};

function fire(key) {
  const url = pixels[key];
  if (!url) return;
  const img = new Image();
  img.referrerPolicy = "no-referrer-when-downgrade";
  img.decoding = "async";
  img.src = url + (url.includes("?") ? "&" : "?") + "cb=" + Date.now();
}

// --- Public API ---
export const initTracking = (cfg) => {
  pixels = cfg?.pixels || {};
  state.insertion = cfg?.insertion || state.insertion;
};

export const tapOnAr = () => {
  // Teads
  fire("tap-on-ar");
  console.log("Tapped on AR button");
};

export const cameraActivated = () => {
  // Teads
  fire("camera-activated");
  console.log("Camera activated");
};

export const modelLoaded = (modelColor) => {
  // Teads
  if (modelColor === "gold") {
    fire("gold-model-loaded");
    console.log("Gold model loaded");
  } else if (modelColor === "silver") {
    fire("silver-model-loaded");
    console.log("Silver model loaded");
  } else if (modelColor === "black") {
    fire("black-model-loaded");
    console.log("Black model loaded");
  }
};

export const interactionWithModel = (modelColor) => {
  // Teads
  if (modelColor === "gold") {
    fire("interaction-w-gold");
    console.log("Interacted with gold model");
  } else if (modelColor === "silver") {
    fire("interaction-w-silver");
    console.log("Interacted with silver model");
  } else if (modelColor === "black") {
    fire("interaction-w-black");
    console.log("Interacted with black model");
  }
};
